import { ChevronSmallRightIcon as ChevronRightIcon } from "@wags/ui/product-icons.tsx";
import type { ReactNode } from "react";

import type { SearchResult } from "@/features/discovery";
import { DogCard } from "@/features/listings";
import { buildUsdMoneyRange } from "@wags/catalog/pure.ts";
import {
    ROW_CLASS,
    ROW_LIST_CLASS,
    ROW_TITLE_TEXT_CLASS,
    rowListItemClass,
} from "./listingRowLayout";

type Props = {
    title: string;
    dogListings: SearchResult["results"];
    onClick: () => void;
    headerAccessory?: ReactNode;
};
export function ListingRow({
    title,
    dogListings,
    onClick,
    headerAccessory,
}: Props) {
    const cards = dogListings.map((d) => ({
        id: d.id,
        name: d.name,
        litter: d.litter,
        imageUrl: d.imageUrls?.[0],
        breedNames: d.breeds.map((b) => b.name),
        priceRange: buildUsdMoneyRange(d.minPrice, d.maxPrice),
    }));

    const titleButton = (
        <button
            type="button"
            onClick={onClick}
            className="group w-fit cursor-pointer flex items-center gap-2.5 rounded-nested outline-none transition-opacity [@media(hover:hover)]:hover:opacity-70 focus-visible:ring-2 focus-visible:ring-labrador-yellow focus-visible:ring-offset-4 focus-visible:ring-offset-true-white"
        >
            <h2 className={ROW_TITLE_TEXT_CLASS}>{title}</h2>
            <span className="mt-0.5 md:mt-0.75 inline-flex size-6 md:size-7 items-center justify-center text-black/60 transition-transform duration-200 motion-reduce:transition-none [@media(hover:hover)]:group-hover:translate-x-0.5">
                <ChevronRightIcon className="size-5 md:size-6" />
            </span>
        </button>
    );

    return (
        <div className={ROW_CLASS}>
            {headerAccessory ? (
                <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-3">
                    {titleButton}
                    {headerAccessory}
                </div>
            ) : (
                titleButton
            )}
            <div className={ROW_LIST_CLASS}>
                {cards.map((d, i) => (
                    <div key={d.id} className={rowListItemClass(i)}>
                        <DogCard
                            {...d}
                            variant="overlay"
                            measurementSurface="find_feed"
                            commitHistoryFirst
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
